import { getDownloadUrl } from "@/api/messageCenter";
import { handleBtn } from "@/pages/freeDownload/interactive";
import { messageCenterRequestUrl } from "@/utils/messageUrl";
import { message } from "antd";
import JSEncrypt from "jsencrypt";

export type DOWNLOAD_BTN="download_2_package" |"download_NDA"


export const downloadBtnIds=[
  {
    id:"download_2_package",
    fetchApi:messageCenterRequestUrl.get2KbDownloadUrl,
    type:'link'
  }, {
    id:"download_NDA",
    fetchApi:messageCenterRequestUrl.getNDADownloadUrl,
    type:'download'
  }
  , {
    id:"file_download",
    fetchApi:messageCenterRequestUrl.getFileDownloadUrl,
    type:'link'
  }
]

export const getDownloadBtn = (signTaskId:any) => {
    downloadBtnIds.forEach((item:any)=>{
      const btn :any=document.getElementById(item.id) || null;
      if(btn==null){
          console.error("can not find download btn");
      }else{
        emitDownloadEvent(item,btn,signTaskId);
      }
    })

    
}



export const emitDownloadEvent=(btnParams:any,btn:any,signTaskId:any)=>{

      btn.onclick=(e:any)=>{
        console.log("package2 download btn clicked",e.target.id);
        getDownloadUrl(signTaskId,btnParams.fetchApi).then((res)=>{
          console.log('getNDADownloadUrl',res);
          if(res.code==200){
            const url=getUrl(res.result);
            console.log('url',url);
            if(url){
              if(btnParams.type=='download'){
                download(url)
              }else{
                console.log('open url',url);
                handleBtn(url);
              }
            }else{
              window.message.error("下载地址解析失败");
            }
          }else{
            window.message.error(res?.message);
          }
        }).catch((err)=>{
          console.error(err);
        });
        
      }
}


const privateKey=`MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAKhNogZbAZq1sybI28vYuACCvaJFcAbPzbRK+uaFXUQI0CADy8xBFpZLXxI1mtcQTBX7uxHM3iJPHMlzezfMxVYQ0ghGYs5pWEE6RSEUoxZzzb6Wpm1++0NZ8e1JNWoyIOEOH+3O6yNw45Rcyb2Pfm8xzkttO3yMpMeTJyvvCqQjAgMBAAECgYAHdpXXlqPeEpj0qyswAWwQvbt0stk9EWxLm+2Urleh7jVzI1KfZp1+oa4AFozHZQDIEscgtXHTmf1/+L/UjB84rOe+nsHiiynST6HW/aTfcCjhKQeL/wvTWZxHhm9idcJ7GuQoNz8zQx0VIlpubTFeYWq/0TosiWuPAgpcLPDzTQJBANDVV9WVaAPSj30zLjsgHTTWJdssVfjJD1sO1DqIQddOfrNnHUSIdGQXsjbw2nn5Q3zsKqrqLtfUNBGNbPAkFi0CQQDOUNsIAYHYuX4bqfbFYXafWiO291Y8LGI7q+YBfFnkUY1LTEt2P/2kMLVRATx/Z+79B/S/B5vgaQFMxhRivOWPAkAJYYwQjCWgBlVrymDJRygIt5X7woIaKu4FqSTffD947I3EgV1PNtIDrQzUav1lfU0Kz5EbHGn+SAoOv8uk/foBAkEAmNR2W+jZ6dQGYbG2tiHrgEGCgU+Y1rw+DFva5rDZ2fK7StL6d18RoaXfOmFDElHITDGvkC6vvj2qk9eLVFT/awJAb9BaaKQUvL+RFauEtdGOR2W+eokvDBcPPkR7sf7Mgj7RkksSdydTrBIGyBMFudPYVH6s/dGor07c1Oe3MGM8rA==`
const publicKey ='MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCoTaIGWwGatbMmyNvL2LgAgr2iRXAGz820SvrmhV1ECNAgA8vMQRaWS18SNZrXEEwV+7sRzN4iTxzJc3s3zMVWENIIRmLOaVhBOkUhFKMWc82+lqZtfvtDWfHtSTVqMiDhDh/tzusjcOOUXMm9j35vMc5LbTt8jKTHkycr7wqkIwIDAQAB'
/**
 * RSA 解密
 * @param word 
 * @returns 
 */
const deCrypt=(word:any)=>{
  const crypt=new JSEncrypt();
  crypt.setPrivateKey(privateKey);
  return crypt.decrypt(word);
}

const encrypt=(word:any)=>{
  const crypt=new JSEncrypt();
  crypt.setPublicKey(publicKey);
  return crypt.encrypt(word);
}

export const download=(url:string)=>{
  const a=document.createElement('a');
  a.href=url;
  a.download="";
  a.click();

}

/**
 * 分段解密数据 并整合
 * @param urls 
 * @returns 
 */
export const getUrl=(urls:string[])=>{
  let str='';
  urls.forEach((url)=>{
    str+=deCrypt(url);
  })
  return str;
}